import { useCallback, useMemo } from 'react';
import { SearchResultObject } from './types';
import { OBJECT_TYPE_PAGES } from './Constants';
import { useBillingNavigation } from '../nav/hooks/useBillingNavigation';

export type MenuItem = {
  url: string;
  label: string;
  parentLabel?: string;
};

export const useSearchableMenuItems = (): {
  menus: MenuItem[];
  searchMenu: (keyword) => SearchResultObject;
} => {
  const { data, isLoading } = useBillingNavigation();

  const menus = useMemo(() => {
    if (isLoading || !data?.menus) {
      return [];
    }
    return data.menus
      .filter((item) => item.url && item.label)
      .map((item) => {
        const parent = data.menus.find((m) => m.id === item.parentId);
        return {
          url: item.url,
          label: item.label,
          parentLabel: parent?.label,
        } as MenuItem;
      });
  }, [data, isLoading]);

  const searchMenu = useCallback(
    (keyword) => {
      const lowerCaseKeyword = keyword.toLowerCase();
      const matchedItems = menus.filter(
        (option) =>
          option.label.toLowerCase().includes(lowerCaseKeyword) ||
          option.parentLabel?.toLowerCase()?.includes(lowerCaseKeyword),
      );
      return {
        objectType: OBJECT_TYPE_PAGES,
        totalCount: matchedItems.length,
        objects: matchedItems,
      };
    },
    [menus],
  );
  return { menus, searchMenu };
};
